import React from "react";

function Public(props: any) {
  return <>{props.children}</>;
}

export default Public;
